
const SpinnerCustom = (
    {
        children,
        className = '',
    }
) => {
    return(
        <div className={`d-flex align-items-center justify-content-center w-100 h-100 ${className}`}>
            {children}
        </div>
    )
}

export default SpinnerCustom